import { Component, OnInit } from '@angular/core';
import { BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleList',
  templateUrl: './BehfaRoleList.component.html',
  styleUrls: ['./BehfaRoleList.component.scss']
})
export class BehfaRoleListComponent implements OnInit {

  Token:String=""

  constructor(
    private BehfaRole_Service:BehfaRoleService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');


    this.Nav_Service.CheckValidPage(this.Token,1108).subscribe(
      data=>{
        this.ReadData_BehfaRole()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  InProccessing:boolean=false
  DataList_Behfa:Array<BehfaRole_Interface>=[]
  ReadData_BehfaRole(){
    this.InProccessing=true
    this.BehfaRole_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.InProccessing=false
        this.DataList_Behfa=data
        if(this.DataList_Behfa.length>0)
        {
          this.DataList_Behfa[0].del=true
        }
      }
    )
  }


  ChangeItem(item:BehfaRole_Interface)
  {
    this.Rest_All()
    item.del=true
  }

  Rest_All(){
    for(let item of this.DataList_Behfa)
    {
      item.del=false
    }
  }

}
